import { LEFT_RIGHT_OFFSET, TOP_BOTTOM_OFFSET } from "../constants";
import { TooltipPosition, TooltipSize } from "../TooltipContent.types";

export const getTooltipContentPosition = (
  content: HTMLDivElement,
  parent: HTMLDivElement,
  position: TooltipPosition,
  size: TooltipSize,
  positionOverride?: { left?: number; top?: number }
): string => {
  const contentRect = content.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  const { left: leftOverride, top: topOverride } = positionOverride || {};
  const minLeft = 16;
  const maxLeft = window.innerWidth - contentRect.width - 16;

  switch (position) {
    case TooltipPosition.Top: {
      const top = parentRect.top - contentRect.height;
      const left = Math.min(
        Math.max(parentRect.left + parentRect.width / 2 - contentRect.width / 2, minLeft),
        maxLeft
      );

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.TopStart: {
      const top = parentRect.top - contentRect.height;
      const left = Math.min(
        Math.max(
          size === TooltipSize.XS ? parentRect.left : parentRect.left - TOP_BOTTOM_OFFSET,
          minLeft
        ),
        maxLeft
      );

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.TopEnd: {
      const top = parentRect.top - contentRect.height;
      const left = Math.min(
        Math.max(
          size === TooltipSize.XS
            ? parentRect.left + parentRect.width - contentRect.width
            : parentRect.left + parentRect.width - contentRect.width + TOP_BOTTOM_OFFSET,
          minLeft
        ),
        maxLeft
      );

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.Right: {
      const top = parentRect.top + parentRect.height / 2 - contentRect.height / 2;
      const left = Math.min(parentRect.left + parentRect.width, maxLeft);

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.RightStart: {
      const top = size === TooltipSize.XS ? parentRect.top : parentRect.top - LEFT_RIGHT_OFFSET;
      const left = Math.min(parentRect.left + parentRect.width, maxLeft);

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.RightEnd: {
      const top =
        size === TooltipSize.XS
          ? parentRect.top + parentRect.height - contentRect.height
          : parentRect.top + parentRect.height - contentRect.height + LEFT_RIGHT_OFFSET;
      const left = Math.min(parentRect.left + parentRect.width, maxLeft);

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.Bottom: {
      const top = parentRect.top + parentRect.height;
      const left = Math.min(
        Math.max(parentRect.left + parentRect.width / 2 - contentRect.width / 2, minLeft),
        maxLeft
      );

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.BottomStart: {
      const top = parentRect.top + parentRect.height;
      const left = Math.min(
        Math.max(
          size === TooltipSize.XS ? parentRect.left : parentRect.left - TOP_BOTTOM_OFFSET,
          minLeft
        ),
        maxLeft
      );

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.BottomEnd: {
      const top = parentRect.top + parentRect.height;
      const left = Math.min(
        Math.max(
          size === TooltipSize.XS
            ? parentRect.left + parentRect.width - contentRect.width
            : parentRect.left + parentRect.width - contentRect.width + TOP_BOTTOM_OFFSET,
          minLeft
        ),
        maxLeft
      );

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.Left: {
      const top = parentRect.top + parentRect.height / 2 - contentRect.height / 2;
      const left = Math.max(parentRect.left - contentRect.width, minLeft);

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.LeftStart: {
      const top = size === TooltipSize.XS ? parentRect.top : parentRect.top - LEFT_RIGHT_OFFSET;
      const left = Math.max(parentRect.left - contentRect.width, minLeft);

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    case TooltipPosition.LeftEnd: {
      const top =
        size === TooltipSize.XS
          ? parentRect.top + parentRect.height - contentRect.height
          : parentRect.top + parentRect.height - contentRect.height + LEFT_RIGHT_OFFSET;
      const left = Math.max(parentRect.left - contentRect.width, minLeft);

      return `translate(${typeof leftOverride === "number" ? leftOverride : left}px, ${typeof topOverride === "number" ? topOverride : top}px)`;
    }
    default: {
      return "";
    }
  }
};
